// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__tlDX7","title":"styles_title__3ADxp"};